import * as React from 'react';
import { Tooltip } from 'antd';
import { Styles } from 'src/Library/Types';

const getStyles = ({
  maxChars,
}) => ({
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: `${maxChars}ch`,
  }
});

interface TextNoWrapProps {
  value: String;
  style?: React.CSSProperties,
  maxChars?: Number;
  [key: string]: any;
}

const TextNoWrap: React.FC<TextNoWrapProps> = ({
  value,
  style = {},
  maxChars = 26,
  placement = 'top',
  ...extraProps
}) => {
  const styles = getStyles({ maxChars }) as Styles<typeof getStyles>;
  styles.text = {
    ...styles.text,
    ...style,
  };

  return <Tooltip title={value} placement={placement}>
    <div style={styles.text} {...extraProps}>
      {value}
    </div>
  </Tooltip>;
};

export default React.memo(TextNoWrap);
